import {
	webAPIConstants
}from "./constants"

const initialState = {
	error     : null,
	isSending : false,
	paged     : {},
	info      : null
}

export default function (state = initialState, action){
	switch (action.type){
		case (webAPIConstants.GetPaged.REQUEST):
		case (webAPIConstants.Register.REQUEST):
		case (webAPIConstants.Reset.REQUEST):
			return {
				...state,
				isSending : true,
				info      : null
			}
		case (webAPIConstants.GetPaged.FAILURE):
		case (webAPIConstants.Register.FAILURE):
		case (webAPIConstants.Reset.FAILURE):
			return {
				...state,
				isSending : false,
				error     : action.payload
			}
		case (webAPIConstants.GetPaged.SUCCESS):
			return {
				...state,
				isSending : false,
				paged     : action.payload.result
			}
		case (webAPIConstants.Register.SUCCESS):
		case (webAPIConstants.Reset.SUCCESS):
			return {
				...state,
				isSending : false,
				info      : action.payload.result
			}
		case (webAPIConstants.CLEAR_INFO):
			return {
				...state,
				info: null
			}
		case (webAPIConstants.CLEAR):
			return {
				...state,
				error     : null,
				isSending : false,
				paged     : {},
				info      : null
			}
		default:
			return state
	}
}